// import './styles.css';
import { Box } from "@mui/material";
// import Modal from "react-modal";
import Modal from '@mui/material/Modal';

export function ModalContent({ showModal, setShowModal, children, onClickOutside }) {

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      height: "90%",
    },
    overlay: {
      backgroundColor: 'rgba(0, 0, 0, 0.4)',

    }
  };

  return (
    <Modal
      isOpen={showModal}
      shouldCloseOnOverlayClick={onClickOutside}
      onRequestClose={() => setShowModal(false)}
      style={customStyles}
      ariaHideApp={false}

    >
      {children}
    </Modal>
  );
}


export function ModalAlert({ showModal, onClose, children, maxHeight }) {
  const customStyles = {
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    position: 'absolute',
    top: "50%",
    left: "50%",
    transform: 'translate(-50%, -50%)',
    borderRadius: '5px',
    maxHeight: maxHeight ? maxHeight : "40%",
    overflow: 'auto'
  }

  return (
    <Modal
      open={showModal}
      disableEscapeKeyDown={true}
      onClose={onClose}
      className="mui-fixed">
      <Box sx={customStyles}>
        {children}
      </Box>
    </Modal>
  )
}

// export function ModalAlert({ showModal, setShowModal, children, onClickOutside }) {

//   const customStyles = {
//     content: {
//       top: "50%",
//       left: "50%",
//       right: "auto",
//       bottom: "auto",
//       marginRight: "-50%",
//       transform: "translate(-50%, -50%)",
//       height: "40%",
//       width: "30%"
//     },
//     overlay: {
//       backgroundColor: 'rgba(0, 0, 0, 0.4)',

//     }
//   };

//   return (
//     <Modal
//       isOpen={showModal}
//       shouldCloseOnOverlayClick={onClickOutside}
//       onRequestClose={() => setShowModal(false)}
//       style={customStyles}
//       ariaHideApp={false}

//     >
//       {children}
//     </Modal>
//   );
// }